import throttle from 'lodash.throttle';
import React, { FC } from 'react';

import { SCROLL_THROTTLE } from '../constants';

type Props = {
  onScrolledToBottom: () => void;
  children: ({ onScroll }: { onScroll: React.UIEventHandler }) => React.ReactNode;
};

const ScrollSubscriber: FC<Props> = (props) => {
  const maybeDispatchScrolledToBottom = throttle((el: HTMLElement) => {
    const heightScrollSum = el.scrollTop + el.offsetHeight;

    if (heightScrollSum < el.scrollHeight) {
      return;
    }

    props.onScrolledToBottom();
  }, SCROLL_THROTTLE);

  const onScroll = (e: React.UIEvent<HTMLElement>) => {
    if (e.target instanceof HTMLElement) {
      maybeDispatchScrolledToBottom(e.target);
    }
  };

  return <>{props.children({ onScroll: onScroll })}</>;
};

export default ScrollSubscriber;
